import requestAxios from '@/utils/request'

export function storeScoreApi (data) {
  return requestAxios.post('enter-score/store', data)
}

export function uploadScoreApi (data) {
  return requestAxios.post('enter-score/upload', data, { headers: {
    'Content-Type': 'multipart/form-data'
  }})
}



// WEBPACK FOOTER //
// ./src/api/enter-score/score.js